import React, { useEffect, useRef, useState } from "react";
import { ChatHeader, ChatInput, ChatUIDefault } from "./ChatMain";
import {
  GetBusinessConsumerChat,
  SalesChatbot,
  UploadBusinessFile,
} from "../Api/ApiEndPoints";
import { callNonStoreApi } from "../NonStoreApis";
import {
  generateUUID,
  isArrayNullOrUndefined,
  isNullOrUndefined,
} from "../utils";
import { useParams } from "react-router";
import { AddFlex } from "../reusableStyles";

function BusinessConsumerChat() {
  const { businessId } = useParams();
  const [profile, setProfile] = useState();
  const [messages, setMessages] = useState();
  const [input, setInput] = useState("");
  const [file, setFile] = useState(null);
  const [fileTextId, setFileTextId] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [messageLoading, setMessageLoading] = useState(false);
  const [aiMessage, setAiMessage] = useState("");
  const fileUploadRef = useRef(null);

  const getPreviousConversation = async () => {
    const userId = localStorage.getItem("businessId");
    let chatId;
    if (isNullOrUndefined(userId) || userId !== businessId) {
      chatId = generateUUID();
      localStorage.setItem("businessId", businessId);
      localStorage.setItem("chatId", chatId);
    } else {
      chatId = localStorage.getItem("chatId");
    }
    const response = await callNonStoreApi(
      GetBusinessConsumerChat.replace(":businessId", businessId).replace(
        ":chatId",
        chatId
      )
    );
    const { chatHistory, businessProfile } = response.data;
    setMessages(chatHistory || []);
    setProfile(businessProfile);
  };

  const sendMessage = async () => {
    try {
      if (!input.trim()) return;
      setMessageLoading(true);

      const userMessage = { content: input, role: "user", message: input };
      if (file) {
        userMessage.file = {
          fileName: file.name,
          type: file.type,
        };
      }
      setInput("");
      setFile(null);
      // make api call.
      setMessages([...messages, userMessage]);
      const response = await callNonStoreApi(SalesChatbot, {
        businessId,
        chatId: localStorage.getItem("chatId"),
        message: userMessage.content,
        fileTextId,
        file,
      });
      const { aiResponse, UIElements } = response.data;
      setInput("");
      setMessageLoading(false);
      setLoading(true);
      setAiMessage("");

      // Simulating AI response with typing effect
      const fullResponse = aiResponse;
      const aiMessage = {
        content: fullResponse,
        role: "assistant",
        UIElements,
      };
      setMessages((prev) => [...prev, aiMessage]);
    } catch (error) {
      console.log(error);
    } finally {
      setMessageLoading(false);
      setLoading(false);
    }
  };

  const handleUpload = async (e) => {
    // setLoading(true);
    // try {
    //   setIsFileUploading(true);
    //   const file = e.target.files[0];
    //   setFile(file);
    //   const formData = new FormData();
    //   formData.append("file", file);
    //   //   formData.append("instaUserId", credentials?.user_id);
    //   const response = await callNonStoreApi(UploadBusinessFile, formData);
    //   const { id } = response.data;
    //   setFileTextId(id);
    // } catch (error) {
    //   console.error("Error uploading file", error);
    // } finally {
    //   setIsFileUploading(false);
    // }
    // setLoading(false);
  };

  useEffect(() => {
    getPreviousConversation();
  }, []);
  return (
    profile && (
      <AddFlex backgroundColor="white" height="100%" style={{ flexGrow: 1 }}>
        {/* <ChatSidebar /> */}
        <AddFlex
          justify="center"
          alignItems="center"
          flexDirection="column"
          gap="30px"
          style={{ width: "100%", height: "100%" }}
        >
          {isArrayNullOrUndefined(messages) ? (
            <AddFlex flexDirection="column" gap="30px" width="50%">
              <ChatHeader
                text={`How can we at ${profile?.business_name} help you.`}
              />
              <ChatInput
                setInput={setInput}
                input={input}
                loading={loading}
                sendMessage={sendMessage}
                messageLoading={messageLoading}
                handleUpload={handleUpload}
              />
            </AddFlex>
          ) : (
            <ChatUIDefault
              handleUpload={handleUpload}
              sendMessage={sendMessage}
              messages={messages}
              messageLoading={messageLoading}
              input={input}
              loading={loading}
              setInput={setInput}
            />
          )}
        </AddFlex>
      </AddFlex>
    )
  );
}

export default BusinessConsumerChat;
